import { Injectable, NgModule, inject } from '@angular/core';
import {
  CategoryActionLoadCategory,
  selectorCategoryCategory
} from '@bepatient/category-store';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs,
  CoreSelectorGuard,
  CoreUtils,
  CoreUtilsService
} from '@bepatient/core';
import { Store } from '@ngrx/store';

@Injectable()
export class CategoryGuard extends CoreSelectorGuard {
  constructor() {
    const store = inject<Store<any>>(Store);

    super(store, selectorCategoryCategory, new CategoryActionLoadCategory());
  }
}

const categoryModule: CorePageModule = {
  ID: CorePageModuleIDs.CATEGORY,
  i18nLabel: 'MODULES.CATEGORY',
  icon: 'copy',
  leftMenuAvailableForDepthModules: true,
  routes: CoreUtils.generateDepthModuleRoutes(
    'category',
    () =>
      import('./pages/category/category.module').then(
        module => module.CategoryPageModule
      ),
    CategoryGuard
  )
};

@NgModule({
  providers: [
    CategoryGuard,
    { provide: CORE_PAGE_MODULE, useValue: categoryModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './category/i18n/', multi: true }
  ]
})
export class CategoryModule {
  constructor() {
    const coreUtilsService = inject(CoreUtilsService);

    coreUtilsService.addDepthModuleRoutes(categoryModule);
  }
}
